/**
 * TPL PDP Motion — three scroll/entrance ports for the mobile product page:
 *   "Scroll pinning"   → the gallery stays put and scales down as the details
 *                        scroll over it (CSS sticky + scroll-linked scale).
 *   "Parallax"         → lifestyle photos drift slower than the page.
 * All scroll work runs in one rAF; everything is off under reduced motion.
 */
(function () {
  'use strict';

  var MOBILE = '(max-width: 749px)';
  var PARALLAX = 0.12;

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function isMobile() { return !!(window.matchMedia && window.matchMedia(MOBILE).matches); }

  function spring(k, d, dur, toFrame) {
    var w0 = Math.sqrt(k), z = d / (2 * w0), f = [];
    for (var i = 0; i <= 40; i++) {
      var t = (i / 40) * dur, wd = w0 * Math.sqrt(1 - z * z);
      var x = 1 - Math.exp(-z * w0 * t) * (Math.cos(wd * t) + (z * w0 / wd) * Math.sin(wd * t));
      f.push(toFrame(x));
    }
    return f;
  }

  /* ── gallery pin ── */
  var media = null, info = null, headerH = 56;
  function pinScale(mediaTop, mediaHeight, infoTop) {
    /* 0 while the details sit below the gallery, 1 once they have covered it */
    var covered = (mediaTop + mediaHeight) - infoTop;
    var p = Math.max(0, Math.min(1, covered / mediaHeight));
    return { scale: 1 - 0.18 * p, opacity: 1 - 0.35 * p, p: p };
  }
  /* ── parallax ── */
  var plx = [];

  /* Perf 2026-10-03 (MotionScore: mobile thrashing F). The pin used to write
     transform/opacity on the gallery and the parallax then measured figures in
     the same frame, forcing a layout each time. Measure everything first, then
     write everything. */
  function readMotion() {
    var pin = null;
    if (media && info) {
      if (!isMobile()) {
        pin = 'reset';
      } else {
        var mr = media.getBoundingClientRect(), ir = info.getBoundingClientRect();
        pin = pinScale(mr.top, mr.height || 1, ir.top);
      }
    }
    var vh = window.innerHeight || 800;
    var par = new Array(plx.length);
    for (var i = 0; i < plx.length; i++) {
      var r = plx[i].fig.getBoundingClientRect();
      /* null = off-screen, leave it alone */
      par[i] = (r.bottom < 0 || r.top > vh) ? null : (-(r.top + r.height / 2 - vh / 2) * PARALLAX).toFixed(1);
    }
    return { pin: pin, par: par };
  }
  function writeMotion(s) {
    if (!s) return;
    if (s.pin === 'reset') {
      media.style.transform = '';
      media.style.opacity = '';
    } else if (s.pin) {
      media.style.transform = 'scale(' + s.pin.scale.toFixed(4) + ')';
      media.style.opacity = s.pin.opacity.toFixed(3);
    }
    for (var i = 0; i < plx.length; i++) {
      if (s.par[i] == null) continue;
      plx[i].img.style.transform = 'translateY(' + s.par[i] + 'px) scale(1.16)';
    }
  }

  var ticking = false, bus = null;
  function onScroll() {
    if (bus) { bus.schedule(); return; }
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; writeMotion(readMotion()); });
  }

  /* Details entrance: handled by the CSS stagger in tpl-product-page.css
     (.product__info-container > *). The JS stagger that duplicated it was
     removed in the 2026-09-08 audit. */

  function boot() {
    if (document.documentElement.dataset.tplPdpMotion === '1') return;
    document.documentElement.dataset.tplPdpMotion = '1';
    if (reducedMotion()) return;

    media = document.querySelector('.product__media-wrapper:not(.medium-hide)') || document.querySelector('.product__media-wrapper');
    info = document.querySelector('.product__info-wrapper');
    if (media && info) {
      /* transform-origin lives in tpl-product-page.css under html.tpl-gallery-pin —
         writing it here forced a layout before the first frame. */
      document.documentElement.classList.add('tpl-gallery-pin');
    }

    document.querySelectorAll('.tpl-size-carousel__slide').forEach(function (fig) {
      var img = fig.querySelector('img');
      if (!img) return;
      fig.classList.add('tpl-plx');
      plx.push({ fig: fig, img: img });
    });

    if (window.TPLScrollBus) {
      bus = window.TPLScrollBus;
      bus.add({ read: readMotion, write: writeMotion });
    } else {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    }
    onScroll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  window.TPLPdpMotion = { pinScale: pinScale, PARALLAX: PARALLAX };
})();
